// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IChangesetChangeDto } from './IChangesetChangeDto';
import {
    IChangesetChangeDtoFromJSON,
    IChangesetChangeDtoFromJSONTyped,
    IChangesetChangeDtoToJSON,
    IChangesetChangeDtoToJSONTyped,
} from './IChangesetChangeDto';
import type { IPageableObject } from './IPageableObject';
import {
    IPageableObjectFromJSON,
    IPageableObjectFromJSONTyped,
    IPageableObjectToJSON,
    IPageableObjectToJSONTyped,
} from './IPageableObject';
import type { ISortOrder } from './ISortOrder';
import {
    ISortOrderFromJSON,
    ISortOrderFromJSONTyped,
    ISortOrderToJSON,
    ISortOrderToJSONTyped,
} from './ISortOrder';

/**
 * 
 * @export
 * @interface IPageChangesetChangeDto
 */
export interface IPageChangesetChangeDto {
    /**
     * 
     * @type {number}
     * @memberof IPageChangesetChangeDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageChangesetChangeDto
     */
    total_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof IPageChangesetChangeDto
     */
    size?: number;
    /**
     * 
     * @type {Array<IChangesetChangeDto>}
     * @memberof IPageChangesetChangeDto
     */
    content?: Array<IChangesetChangeDto>;
    /**
     * 
     * @type {number}
     * @memberof IPageChangesetChangeDto
     */
    number?: number;
    /**
     * 
     * @type {Array<ISortOrder>}
     * @memberof IPageChangesetChangeDto
     */
    sort?: Array<ISortOrder>;
    /**
     * 
     * @type {IPageableObject}
     * @memberof IPageChangesetChangeDto
     */
    pageable?: IPageableObject;
    /**
     * 
     * @type {number}
     * @memberof IPageChangesetChangeDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IPageChangesetChangeDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageChangesetChangeDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IPageChangesetChangeDto
     */
    empty?: boolean;
}

/**
 * Check if a given object implements the IPageChangesetChangeDto interface.
 */
export function instanceOfIPageChangesetChangeDto(value: object): value is IPageChangesetChangeDto {
    return true;
}

export function IPageChangesetChangeDtoFromJSON(json: any): IPageChangesetChangeDto {
    return IPageChangesetChangeDtoFromJSONTyped(json, false);
}

export function IPageChangesetChangeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPageChangesetChangeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
        'size': json['size'] == null ? undefined : json['size'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IChangesetChangeDtoFromJSON)),
        'number': json['number'] == null ? undefined : json['number'],
        'sort': json['sort'] == null ? undefined : ((json['sort'] as Array<any>).map(ISortOrderFromJSON)),
        'pageable': json['pageable'] == null ? undefined : IPageableObjectFromJSON(json['pageable']),
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'first': json['first'] == null ? undefined : json['first'],
        'last': json['last'] == null ? undefined : json['last'],
        'empty': json['empty'] == null ? undefined : json['empty'],
    };
}

export function IPageChangesetChangeDtoToJSON(json: any): IPageChangesetChangeDto {
    return IPageChangesetChangeDtoToJSONTyped(json, false);
}

export function IPageChangesetChangeDtoToJSONTyped(value?: IPageChangesetChangeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalPages': value['total_pages'],
        'totalElements': value['total_elements'],
        'size': value['size'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IChangesetChangeDtoToJSON)),
        'number': value['number'],
        'sort': value['sort'] == null ? undefined : ((value['sort'] as Array<any>).map(ISortOrderToJSON)),
        'pageable': IPageableObjectToJSON(value['pageable']),
        'numberOfElements': value['number_of_elements'],
        'first': value['first'],
        'last': value['last'],
        'empty': value['empty'],
    };
}

